import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';

interface Props {
  partitionParLevels: [string, number][];
}

export const OrderGuideInfoParLevelTable: React.FC<Props> = ({
  partitionParLevels,
}) => {
  const [styles] = useStyles();

  // Render partition names and their respective par levels in separate
  // flexbox items so the column widths are dynamic but equal for rows
  return partitionParLevels.length ? (
    <View style={styles.parTable}>
      <View style={styles.parTablePartitions}>
        {partitionParLevels.map(([partitionName]) => (
          <Text
            key={partitionName}
            numberOfLines={1}
            style={[TYPOGRAPHY.xsmall, styles.partitionName, styles.text]}
          >
            {partitionName}
          </Text>
        ))}
      </View>
      <View style={styles.parTableParLevels}>
        {partitionParLevels.map(([partitionName, parLevel]) => (
          <Text
            key={partitionName}
            style={[TYPOGRAPHY.xsmall, FONTS.primarySemiBold, styles.text]}
          >
            {i18n.t('par_level', { number: parLevel })}
          </Text>
        ))}
      </View>
    </View>
  ) : null;
};

const useStyles = createStyles((theme) => ({
  parTable: {
    flexDirection: 'row',
  },
  parTableParLevels: {
    paddingLeft: 8,
  },
  parTablePartitions: {
    alignItems: 'flex-end',
  },
  partitionName: {
    maxWidth: 120,
  },
  text: {
    color: theme.colors.inactiveText,
    fontFamily: theme.fonts.primary,
  },
}));
